import React, { Component } from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  color: #cccccc;

  .active{
      color: #42ca7c;
  }
`;

const Icon = styled.span`
  display: block;
  font-size: 26px;
  text-align: right;
  margin-top: -37px;
  margin-left: 207px;
  width: 26px;
  float: left;
`;

export default class CardValid extends Component {
  render() {
    return (
      <Wrapper>
        <div className="card-valid">
          <Icon className="fa fa-check"></Icon>
          <Icon className="fa fa-error"></Icon>
        </div>
      </Wrapper>
    );
  }
}
